// Entry point for esbuild

// Core dependencies
import $ from 'jquery'
import * as Turbo from '@hotwired/turbo'
import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/mouse'
import 'jquery-ui/ui/widgets/slider'
import 'jquery-ui/ui/position'
import 'jquery-ui/ui/widgets/menu'
import 'jquery-ui/ui/widgets/autocomplete'
import 'jquery-ui/ui/effect'
import 'jquery-ui/ui/effects/effect-highlight'
import * as bootstrap from 'bootstrap'
import 'cookieconsent'
import 'iframe-resizer'

// Make jQuery and Bootstrap global for legacy code during migration
window.$ = window.jQuery = $
window.bootstrap = bootstrap

// Start Turbo for turbo_stream support
Turbo.start()

// Import core modules
import './modules/ajax'
import './modules/size_formatter'
import './modules/search'
import './modules/locale'
import './modules/profile_frame_scroll'
import './modules/profile_rail_drawer'
import './modules/rangy_editor'
import './modules/cookie_consent'
import './modules/analytics'
import './modules/turbo_stream_actions'
import './modules/turbo_confirm'

// Import feature modules
import './features/checkouts/index'

// Import Stimulus controllers (auto-registered via controllers/index.js)
import "./controllers"

import { displayInitialCustomerPartNumber } from './features/product_lines/putup/customer-part-number'

document.addEventListener('turbo:load', () => {
  displayInitialCustomerPartNumber()
})

document.addEventListener('product-selection:updated', () => {
  const controller = window.Stimulus.getControllerForElementAndIdentifier(
    document.querySelector('[data-controller="product-selection"]'),
    'product-selection'
  )
  controller?.reattachHandlers()
})

console.log('esbuild application loaded successfully')
